import { render, staticRenderFns } from "./Shfw.vue?vue&type=template&id=234f436f&scoped=true&"
import script from "./Shfw.vue?vue&type=script&lang=js&"
export * from "./Shfw.vue?vue&type=script&lang=js&"
import style0 from "./Shfw.vue?vue&type=style&index=0&id=234f436f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f436f",
  null
  
)

export default component.exports